import React from 'react';
import { ColorKey, COLOR_VALUES, ShapeKind } from '../utils/stones';
interface StoneProps {
  shape: ShapeKind;
  color: ColorKey;
  size?: number;
}
const LABELS: Record<ShapeKind, string> = {
  heart: 'Herz',
  square: 'Quadrat',
  octagon: 'Achteck',
  pill: 'Rechteck'
};
export function Stone({
  shape,
  color,
  size = 44
}: StoneProps) {
  const fill = COLOR_VALUES[color];
  const title = `${LABELS[shape]}`;
  return <svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label={title} className="drop-shadow-sm" data-id="element-29">
      {shape === 'heart' && <path d="M50 86 L18 53 C5 40 8 20 25 16 C36 13 46 19 50 28 C54 19 64 13 75 16 C92 20 95 40 82 53 Z" fill={fill} data-id="element-30" />}
      {shape === 'square' && <rect x="18" y="18" width="64" height="64" rx="12" fill={fill} data-id="element-31" />}
      {shape === 'octagon' && <polygon points="34,14 66,14 86,34 86,66 66,86 34,86 14,66 14,34" fill={fill} data-id="element-32" />}
      {shape === 'pill' && <rect x="10" y="36" width="80" height="28" rx="14" fill={fill} data-id="element-33" />}
    </svg>;
}